let {
  REACT_APP_MDO_API_URL,
  REACT_APP_SURPRISE_API_URL,
  REACT_APP_FORMALIZATION_API_URL,
} = process.env

let baseRoute = '/auto'
let communicationUrl = '/comunicacao/minhas-ligacoes'

const isProxy = () =>
  typeof window !== 'undefined' &&
  (window.location.host === 'backoffice.creditas.io' ||
    window.location.host === 'backoffice-staging.creditas.io')

if (isProxy()) {
  REACT_APP_MDO_API_URL = '/api/auto-equity-sales-engagement/core'
  REACT_APP_FORMALIZATION_API_URL =
    '/api/auto-equity-sales-engagement/formalization'
  REACT_APP_SURPRISE_API_URL = '/api/auto-equity-sales-engagement/surprise'
  baseRoute = '/auto-equity'
  communicationUrl = 'https://mdo.creditas.com.br/comunicacao/minhas-ligacoes'
}

const config = {
  apiGateway: {
    coreApiUrl: REACT_APP_MDO_API_URL,
    surpriseApiUrl: REACT_APP_SURPRISE_API_URL,
    formalizationApiUrl: REACT_APP_FORMALIZATION_API_URL,
  },
  externalUrls: {
    communication: communicationUrl,
  },
  baseRoute,
}

export { config, isProxy }
